import { createContext, useContext } from "react";

export const BusinessContext = createContext({
  selectedBusiness: null,
  businesses: [],
});

export function useSelectedBusiness() {
  return useContext(BusinessContext);
}
